import React, { Component } from 'react';
import './Submissions.css';
import {Link as RouterLink} from 'react-router-dom' ; 
import Header from '../../components/partials/HeaderComponent';
import Footer from '../../components/partials/FooterComponent';
import axios from 'axios';
import { connect } from 'react-redux';
import parse from 'html-react-parser';

const verdict = {
    "AC": '<span class="text-success"><span class="fa fa-check-circle"></span> Accepted</span>',
    "WA": '<span class="text-danger"><span class="fa fa-times-circle"></span> Wrong Answer</span>',
    "TLE": '<span class=""><span class="fa fa-hourglass-end"></span> Time Limit Exceeded</span>',
    "RE": '<span class="text-danger">Runtime Error</span>',
    "CE": '<span class="text-danger">Compiletime Error</span>'
};

class Submissions extends Component {

    state = {
        contestName: "",
        submissions: [],
    }

    componentDidMount() {
        axios.post("https://server.codeium.tech/contest/submissions", {
            username: this.props.username,
            contest_id: this.props.match.params.contestId
        }).then(res => {
            this.setState({submissions: res.data.msg})
        })
        .catch(err => {
            // console.log(err);
        })

        axios.post("https://server.codeium.tech/contest/name", {
            contest_id: this.props.match.params.contestId,
            username: this.props.username
        }).then(res => {
            this.setState({
                contestName: res.data.msg[0].contest_name
            })
        }).catch(err => {
            // console.log(err);
        })
    }

    render() {
        return (
            <>
                <Header />
                <div className="container my-5">
                    <h1 className="primary-heading">{this.state.contestName}</h1>
                    <div className="row">
                        <div className="col-12">
                            <div className="tab-container Leaderboard p-3">
                                <div className="row">
                                    <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb bg-transparent pb-1">
                                        <RouterLink to={"/contests"}>
                                            <li class="breadcrumb-item underline">
                                                <a  className="SubmissionLinks" href="#">Contests</a>
                                            </li>
                                        </RouterLink>
                                        { " >> "}
                                        <RouterLink to={"/contests/" + this.props.match.params.contestId + "/"}>
                                            <li class="breadcrumb-item underline">
                                                <a  className="SubmissionLinks" href="#">{this.state.contestName}</a>
                                            </li>
                                        </RouterLink>
                                        { " >> "}
                                        <RouterLink to={"/contests/" + this.props.match.params.contestId + "/problems"}>
                                            <li class="breadcrumb-item underline">
                                                <a className="SubmissionLinks" >Problems</a>
                                            </li>
                                        </RouterLink>
                                        { " >> "}
                                        <li class="breadcrumb-item active" aria-current="page" className="SubmissionName">
                                            Submissions
                                        </li>
                                    </ol>
                                    </nav>
                                </div>
                                <h3 className="mt-2">Submissions</h3>
                                {/* <hr className="bg-dark mt-0" /> */}
                                <div className="row mt-3">
                                    <div className="col-12">
                                        <table className="table table-responsive-md table-md Problem_Table">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th scope="col">Problem</th>
                                                    <th scope="col">Result</th>
                                                    <th scope="col">Language</th>
                                                    <th scope="col">Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.submissions?.map((submission) => {
                                                    let styles = {};
                                                    let styleclass = ""
                                                    if (submission.verdict === "WA" || submission.verdict === "RE" || submission.verdict === "CE") {
                                                        styleclass = "table-danger";
                                                        styles = { backgroundColor: "#f5c6cb" };
                                                    } else if (submission.verdict === "AC") {
                                                        styleclass = "table-success";
                                                        styles = { backgroundColor: "#c3e6cb" };
                                                    }
                                                    else if (submission.verdict === "TLE") {
                                                        styleclass = "table-warning";
                                                        styles = { backgroundColor: "#fff1c8" };
                                                    }
                                                    return (
                                                        <tr
                                                        // className={styleclass}
                                                        style={styles}
                                                        >
                                                        <td>{submission.problem_title}</td>
                                                        <td>{parse(verdict[submission.verdict])}</td>
                                                        <td>{submission.language}</td>
                                                        <td>{new Date(submission.submission_time).toLocaleTimeString([], { month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' })}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        username: state.auth.username
    }
}

export default connect(mapStateToProps)(Submissions);